// Announcement
var tryCount = 0;
function initAnnouncement() {
    var CookieName = "announcements";
    var closeButton = document.getElementById('announcement__close');
    var announcementPanel = document.querySelector('.announcement');

    if (closeButton == null || announcementPanel == null) {
        console.error('No panel or close button found for announcement');
    } else {
        // Read more / Read less toggle
        var contentWrap = document.querySelector('.announcement__content-wrap');
        var content = document.querySelector('.announcement__content');
        var readMoreBtn = document.getElementById('announcement__read-more');

        if (content && readMoreBtn) {
            if (content.scrollHeight > content.clientHeight) {
                readMoreBtn.classList.add('is-visible');
                if (contentWrap) contentWrap.classList.add('has-overflow');
            }

            readMoreBtn.addEventListener('click', function () {
                var isExpanded = content.classList.contains('is-expanded');
                if (isExpanded) {
                    content.style.maxHeight = '120px';
                    content.classList.remove('is-expanded');
                    if (contentWrap) contentWrap.classList.remove('is-expanded');
                    readMoreBtn.textContent = 'Read more';
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    content.classList.add('is-expanded');
                    if (contentWrap) contentWrap.classList.add('is-expanded');
                    readMoreBtn.textContent = 'Read less';
                }
            });
        }

        var announcementId = announcementPanel.getAttribute('data-announcement-id');
        var updateDate = document.getElementById('createdDate').value;

        closeButton.addEventListener("click", function () {
            var dateTime = new Date();

            // Remove the entire wrapper from the DOM so its margin-bottom
            // disappears instantly and the CSS sibling selector
            // (.announcement__wrap + main) stops matching — restoring any
            // padding/margin on the first content element below.
            var announcementWrapper = announcementPanel.closest('.announcement__wrap');
            if (announcementWrapper) {
                announcementWrapper.remove();
            } else {
                announcementPanel.classList.add('hidden');
            }

            let announcements = {};
            let cookieValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(`${CookieName}=`));

            if (cookieValue) {
                let value = cookieValue.split('=')[1];
                announcements = JSON.parse(decodeURIComponent(value));
            }

            announcements[announcementId] = {
                createdDate: moment(dateTime).format('YYYY-MM-DD , h:mm:ss a'),
                closed: true
            };

            document.cookie = `${CookieName}=${encodeURIComponent(JSON.stringify(announcements))}; path=/; expires=${new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()}; domain=${window.location.hostname}`;
        });

        let cookieValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(`${CookieName}=`));
        let announcements = {};

        if (cookieValue) {
            let value = cookieValue.split('=')[1];
            announcements = JSON.parse(decodeURIComponent(value));
        }

        //if (announcements[announcementId] && announcements[announcementId].closed) {
        //    let cookieDate = moment(announcements[announcementId].createdDate, 'YYYY-MM-DD , h:mm:ss a');
        //    let updateDateMoment = moment(updateDate, 'YYYY-MM-DD , h:mm:ss a');

        //    if (updateDateMoment.isAfter(cookieDate)) {
        //        // Reset the cookie and ensure the announcement is displayed
        //        delete announcements[announcementId];
        //        document.cookie = `${CookieName}=${encodeURIComponent(JSON.stringify(announcements))}; path=/; expires=${new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()}; domain=${window.location.hostname}`;
        //        announcementPanel.classList.remove('hidden');
        //    } else {
        //        // Only hide the announcement if the update date is not newer
        //        announcementPanel.classList.add('hidden');
        //    }
        //} else {
        //    // Ensure the announcement is visible if no valid cookie exists
        //    announcementPanel.classList.remove('hidden');
        //}
    }
};

function deferAnnouncement(method) {
    if (tryCount > 20) {
        console.error('moment object was never populated. Failed to setup announcement');
    } else {
        if (typeof moment !== 'undefined') {
            console.log('All loaded and ready for announcement cookies');
            method();
        } else {
            setTimeout(function () {
                console.log('Awaiting for 50ms before calling defer again');
                tryCount++;
                deferAnnouncement(method);
            }, 50);
        }
    }
}

deferAnnouncement(function () {
    initAnnouncement();
});